import styles from "./toolbox-components.module.css";

interface ToolboxComponentSectionProps {
  title?: string;
  children: React.ReactNode;
}

export const ToolboxComponentSection = (
  props: ToolboxComponentSectionProps
) => {
  return (
    <div className={styles.sectionContainer}>
      {props.title && (
        <div className={styles.sectionTitleContainer}>
          <span className={styles.sectionTitle}>{props.title}</span>
        </div>
      )}
      {props.children}
    </div>
  );
};

interface ToolboxSectionDividerProps {
  whitespaceOnly?: boolean;
}
export const ToolboxSectionDivider = ({
  whitespaceOnly = false,
}: ToolboxSectionDividerProps) => {
  return (
    <div
      className={
        whitespaceOnly ? styles.sectionDividerWhitespace : styles.sectionDivider
      }
    />
  );
};
